export const analyticsId = {
  CLICK_PHONE: 'CLICK_PHONE',
  ERROR_VIEW: 'ERROR_VIEW',
  RETRY_BUTTON: 'RETRY_BUTTON',
};

export const catalogue = {
  [analyticsId.CLICK_PHONE]: () => ({
    categoriaEvento: 'interaccion en migracion error general',
    accionEvento: 'error general',
    etiquetaEvento: 'reintentar',
    action: 'retry',
    format: 'button',
    component: 'emptyState',
    element: 'tryAgain',
  }),
  [analyticsId.ERROR_VIEW]: error => ({
    pageName: '/migration/error/generalError',
    sectionFamily: 'banking',
    sectionCategory: 'services',
    sectionName: 'customer',
    interactionType: 'funnel',
    serviceType: 'userSettings',
    errorCategory: 'generalError',
    errorDescription: error,
    nombrePagina: 'migracion error general',
    tipoPagina: 'generica',
  }),
  [analyticsId.RETRY_BUTTON]: () => ({
    categoriaEvento: 'interaccion en migracion error general',
    accionEvento: 'error general',
    etiquetaEvento: 'reintentar',
    action: 'retry',
    format: 'button',
    component: 'emptyState',
    element: 'tryAgain',
  }),
};
